import React, { useContext, useEffect, useState, useCallback } from "react";
import {
  Box, Typography, TextField, IconButton, Avatar, Divider, Tabs, Tab, Paper
} from "@mui/material";
import { Send, Search } from "@mui/icons-material";
import profilePic from "../../Assets/mentorImg1.png";
import { AuthContext } from '../../Helpers/Contexts/authContext';
import { AuthUser } from '../../interfaces/Contexts';
import {
  getallGroup,
  getNetworks,
  GetRecentMessages,
  getCommonChatRoom,
  createChatRoom,
  getBasicProfileSetting
} from '../../Utils/apiService';
import { format, parseISO } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import SockJS from 'sockjs-client';
import { Stomp } from '@stomp/stompjs';
import KenLoader from '../../GlobalComponents/KenLoader';
import { useStyles } from './style';
import Picker from "@emoji-mart/react";
import { useTheme, useMediaQuery } from '@mui/material';
import EmojiEmotionsOutlinedIcon from '@mui/icons-material/EmojiEmotionsOutlined';
const Chats = () => {
  const classes = useStyles();
  const {
    state: { user }
  } = useContext(AuthContext);
  const userData = user as AuthUser;
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState(0);
  const [selectedChat, setSelectedChat] = useState<any>(null);
  const [chatMessages, setChatMessages] = useState<any[]>([]);
  const [newMessage, setNewMessage] = useState("");
  const [networkChat, setNetworkChat] = useState<any[]>([]);
  console.log(networkChat, "networkChatnetworkChatnetworkChat");

  const [groupChats, setGroupChats] = useState<any[]>([]);
  const [expandedMessages, setExpandedMessages] = useState<{ [key: number]: boolean }>({});
  const [stompClient, setStompClient] = useState<any>(null);
  const [chatRoomId, setChatRoomId] = useState<string | null>(null);
  const [profileUrl, setProfileUrl] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);

  // === Fetch Profile Picture & Network ===
  useEffect(() => {
    getBasicProfileSetting(userData?.applicantId).then((res) => {
      setProfileUrl(res?.accountDetails?.Profile_Picture_URL__c);
    });

    fetchNetworkChats();
  }, [userData?.applicantId]);

  const fetchNetworkChats = async () => {
    setLoading(true);
    try {
      const res = await getNetworks(userData?.applicantId);
      const formatted = res?.data?.con.map((chat: any) => ({
        id: chat.Id,
        name: chat.Name,
        message: "Hey, what's up?",
        time: "Just now",
        avatar: chat.Profile_Picture_URL__c || "https://via.placeholder.com/40",
        isOnline: chat.Ken_Alumni_CRM__r?.records?.[0]?.Is_Logged_In__c || false,
      }));
      setNetworkChat(formatted);
    } catch (error) {
      console.error("Error fetching network:", error);
    }
    setLoading(false);
  };

  // === Fetch Groups ===
  const fetchGroups = async () => {
    setLoading(true);
    try {
      const res = await getallGroup(userData?.applicantId);
      const mapGroup = (group: any) => ({
        groupName: group.Title__c,
        id: group.Id,
        ChatRoomId__c: group.ChatRoomId__c,
        avatar: group.Cover_Image_Url__c || "https://via.placeholder.com/40",
      });

      const memberGroupsData = res?.data?.data?.memberGroups?.map(mapGroup) || [];
      const combinedGroups = [...memberGroupsData];
      setGroupChats(combinedGroups);
    } catch (err) {
      console.error("Error fetching groups:", err);
    }
    setLoading(false);
  };

  // === Handle Tab Switch ===
  const handleTabChange = (event: any, newValue: number) => {
    setNetworkChat([]);
    setGroupChats([]);
    setTabValue(newValue);
    setSelectedChat(null);
    setSearchTerm('');
    setChatMessages([]);
    setNewMessage("")

    if (newValue === 0) {
      fetchNetworkChats();
    } else {
      fetchGroups();
    }
  };

  // === Current List Filtering ===
  const currentChatList = (tabValue === 0 ? networkChat : groupChats).filter((item) => {
    const target = item.name || item.groupName;
    return target?.toLowerCase().includes(searchTerm.toLowerCase());
  });
  console.log(currentChatList, "currentChatListcurrentChatListcurrentChatListcurrentChatList");

  // === Chat Room Creation ===
  const fetchOrCreateChatRoom = useCallback(async () => {
    if (!selectedChat?.id) return;
    setLoading(true);
    try {
      const chatRoom: any = await getCommonChatRoom(userData.applicantId, selectedChat.id);

      if (chatRoom?.data?.data?.length === 0) {
        const payload = {
          name: 'p2p chat',
          participantIds: [userData.applicantId, selectedChat.id],
          adminId: userData.applicantId,
        };

        const createRoomResponse = await createChatRoom(payload);
        if (createRoomResponse?.data?.success) {
          const createdChatRoom = createRoomResponse.data.data;
          setChatRoomId(createdChatRoom.id);
        } else {
          throw new Error('Chat room creation failed');
        }
      } else {
        setChatRoomId(chatRoom.data.data[0]?.id);
      }
    } catch (error) {
      console.error('Chat room error:', error);
    }
    setLoading(false);
  }, [userData.applicantId, selectedChat]);

  // === Chat Room Setup ===
  useEffect(() => {
    if (!selectedChat) return;
    if (tabValue === 0) {
      fetchOrCreateChatRoom();
    } else {
      setChatRoomId(selectedChat?.ChatRoomId__c);
    }
  }, [selectedChat, tabValue, fetchOrCreateChatRoom]);

  // === WebSocket Connection ===
  useEffect(() => {
    if (!chatRoomId) return;

    const socket = new SockJS(`https://turbosend-dev-bam-api.turboverse.co/chat-websocket`);
    const client = Stomp.over(socket);

    client.connect({}, () => {
      setStompClient(client);
      const subscription = client.subscribe(`/topic/chatRoom/${chatRoomId}`, (message: any) => {
        const receivedMessage = JSON.parse(message.body);
        setChatMessages((prevMessages) => [...prevMessages, receivedMessage]);
      });

      return () => {
        subscription.unsubscribe();
        client.disconnect();
      };
    });

    return () => {
      client.disconnect();
    };
  }, [chatRoomId]);

  // === Fetch Messages on ChatRoom Change ===
  useEffect(() => {
    if (!chatRoomId) return;
    const fetchMessages = async () => {
      setLoading(true);
      try {
        const response = await GetRecentMessages(chatRoomId, 1, 20);
        setChatMessages(response?.data?.data || []);
      } catch (error) {
        console.error("Error fetching messages:", error);
      }
      setLoading(false);
    };

    fetchMessages();
  }, [chatRoomId]);

  // === Helpers ===
  const formatDate = (timestamp: string) => format(parseISO(timestamp), 'MMMM d, yyyy');

  const groupMessagesByDate = (messages: any[]) => {
    const grouped: { [key: string]: any[] } = {};
    messages.forEach((message) => {
      const dateLabel = formatDate(message.timestamp);
      if (!grouped[dateLabel]) grouped[dateLabel] = [];
      grouped[dateLabel].push(message);
    });
    return grouped;
  };

  const handleSendMessage = () => {
    if (!newMessage.trim() || !stompClient || !chatRoomId) return;

    const messagePayload = {
      content: newMessage.trim(),
      senderId: userData.applicantId,
      chatRoomId,
      attachmentUrl: null,
      timestamp: new Date().toISOString(),
      userName: userData?.applicantName,
    };
console.log(messagePayload, 'messagePayload');

    stompClient.send('/app/sendMessage', { Authorization: `Bearer ${userData?.turbosendToken?.idToken}` }, JSON.stringify(messagePayload));
    setNewMessage('');
  };

  const groupedMessages = groupMessagesByDate(chatMessages);


  
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const handleChatSelection = (chat: any) => {
    if (isMobile) {
      navigate(`/chats/${chat.id}`, { state: { chat } });
    } else {
      if (selectedChat?.id !== chat.id) {
        setSelectedChat(chat);
        setNewMessage("");
        setChatMessages([]);
        setChatRoomId(null);
      }
    }
  };
  return (
    <Box sx={{ p: 1, bgcolor: "white", border: '1px solid #E7E7E7', borderRadius: 2, minHeight: '81vh', width: '100%' }}>
      {loading && <KenLoader />}
      <Box sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', minHeight: '81vh', margin: 1 }}>
        {/* Left Panel */}
        <Box sx={{ border: '1px solid #E7E7E7', borderRadius: 2, p: 2, borderRight: 'none', width: {
          xs: '100%',
          sm: '50%',
          md: '50%',
          
        } }}>
          <Tabs value={tabValue} onChange={handleTabChange} variant="fullWidth" sx={{ mb: 2 }}>
            <Tab label="Network" />
            <Tab label="Groups" />
          </Tabs>

          <TextField
            fullWidth
            key={tabValue}
            size="small"
            variant="standard"
            placeholder="Search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: <Search sx={{ color: "#8C8E94", mr: 1 }} />,
              disableUnderline: true,
              sx: { fontSize: "14px", p: 1, fontFamily: "Figtree, sans-serif" },
            }}
            sx={{ mb: 2, border: '1px solid #E7E7E7', borderRadius: 2 }}
          />

          <Box sx={{ display: 'flex', gap: 2, flexDirection: 'column', height: '70vh', overflowY: 'auto' }}>
            {currentChatList.map((chat) => (
              <Box
                key={chat.id}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  p: 1,
                  borderRadius: 2,
                  cursor: "pointer",
                  bgcolor: "#F6F8FB",
                  border: selectedChat?.id === chat.id ? '1px solid #2C58E8' : 'none',
                }}
                onClick={() => handleChatSelection(chat)} // Use the new handler
              >
                <Box sx={{ position: 'relative', display: 'inline-block' }}>
                  <Avatar src={chat.avatar || profilePic} />
                  {chat?.isOnline === true && (
                    <Box
                      sx={{
                        position: 'absolute',
                        bottom: 2,
                        right: -1,
                        width: 12,
                        height: 12,
                        bgcolor: '#44b700',
                        borderRadius: '50%',
                        border: '2px solid white',
                        zIndex: 1,
                      }}
                    />
                  )}
                </Box>
                <Box sx={{ ml: 3, flexGrow: 1, textAlign: 'left' }}>
                  <Typography>{chat.name || chat.groupName}</Typography>
                  <Typography>{chat.message || "No messages yet"}</Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>

        {/* Right Panel */}
        {!isMobile  && (
        <Box sx={{ display: "flex", flexDirection: "column", borderRadius: 2, p: 2, border: '1px solid #E7E7E7', width: '100%' }}>
          {selectedChat && (
            <>
              <Box sx={{ display: "flex", alignItems: "center", pb: 1, borderBottom: "1px solid #E0E0E0", gap: 2 }}>
                <Avatar src={selectedChat.avatar || profilePic} />
                <Typography>{selectedChat.name || selectedChat.groupName}</Typography>
              </Box>

              <Box sx={{ flexGrow: 1, overflowY: "auto", maxHeight: "70vh" }}>
                {Object.keys(groupedMessages).map((date, index) => (
                  <React.Fragment key={`date-${index}`}>
                    <Box sx={{ textAlign: "center", color: "#777", fontSize: "12px", my: 1 }}>{date}</Box>
                    {groupedMessages[date].map((msg, messageIndex) => (
                      <Box
                        key={messageIndex}
                        sx={{
                          display: "flex",
                          py: 1,
                          justifyContent: msg.senderId === userData.applicantId ? "flex-end" : "flex-start",
                          gap: 1,
                        }}
                      >
                        {msg.senderId !== userData.applicantId && <Avatar src={selectedChat.avatar || profilePic} sx={{ width: '30px', height: '30px' }} />}
                        <Paper
                          sx={{
                            p: 1,
                            maxWidth: "70%",
                            borderRadius: 1,
                            bgcolor: msg.senderId === userData.applicantId ? "#5981FF" : "#F1F1F1",
                            color: msg.senderId === userData.applicantId ? "white" : "#38151D",
                          }}
                        >
                          {msg.content}
                        </Paper>
                        {msg.senderId === userData.applicantId && <Avatar src={profileUrl || profilePic} sx={{ width: '30px', height: '30px' }} />}
                      </Box>
                    ))}
                  </React.Fragment>
                ))}
              </Box>

              <Divider />

              <Box sx={{ display: "flex", alignItems: "center", mt: 2, gap: 1 }}>
                <TextField
                  fullWidth
                  size="small"
                  variant="standard"
                  placeholder="Type a message..."
                  value={newMessage}
                  onChange={(e) => setNewMessage(e.target.value)}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter' && !event.shiftKey) {
                      handleSendMessage(); // Call handleSendMessage when Enter is pressed
                      event.preventDefault(); // Prevent default behavior (e.g., form submission)
                    }
                  }}
                  InputProps={{ disableUnderline: true }}
                  sx={{ border: '1px solid #E7E7E7', borderRadius: 2, marginRight: 1 }}
                />
                {showEmojiPicker && (
                  <Box sx={{ position: 'absolute', bottom: '60px', right: '10px', zIndex: 1000 }}>
                    <Picker
                      onEmojiSelect={(emoji: { native: string }) => {
                        setNewMessage((prev) => prev + emoji.native); // Append emoji to the message
                      }}
                    />
                  </Box>
                )}
                <IconButton onClick={() => setShowEmojiPicker((prev) => !prev)}>
                  <EmojiEmotionsOutlinedIcon />
                </IconButton>
                <IconButton color="primary" onClick={handleSendMessage}>
                  <Send />
                </IconButton>
              </Box>
            </>
          )}
        </Box>
        )}
      </Box>
    </Box>
  );
};

export default Chats;